<template>
  <!-- <page> -->
  <div :load="doInit">
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
                <v-expansion-panel-header>
                  <div>
                    <v-icon>mdi-filter-variant</v-icon> {{labels.dateRange}}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex xs12 sm6 md6 lg6>
                            <cal-picker v-model="reportForm.tranDateFrom" :label="labels.tranDateFrom" :data-vv-as="labels.tranDateFrom"
                            data-vv-name="reportForm.tranDateFrom" :error-messages="errors.collect('reportForm.tranDateFrom')" v-validate="tranDateFromValidation"></cal-picker>
                          </v-flex>
                          <v-flex xs12 sm6 md6 lg6>
                            <cal-picker v-model="reportForm.tranDateTo" :label="labels.tranDateTo" :data-vv-as="labels.tranDateTo"
                            data-vv-name="reportForm.tranDateTo" :error-messages="errors.collect('reportForm.tranDateTo')" v-validate="tranDateToValidation"></cal-picker>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          <v-spacer class="mt-2"></v-spacer>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                 <v-icon>mdi-filter-variant</v-icon> {{labels.filters}}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <!-- Direct/RI -->
                        <v-flex xs6>
                          <v-autocomplete :items="driList" v-model="reportForm.dri" :label="labels.dri" item-text="label" item-value="value" data-vv-name="dri" :data-vv-as="labels.dri"
                          :error-messages="errors.collect('dri')"></v-autocomplete>
                        </v-flex>
                        <!-- Underwriting Year -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field readonly v-model="reportForm.uwYr" :label="labels.uwYr" :error-messages="errors.collect('uwYr')"
                          :data-vv-as="labels.uwYr" data-vv-name="uwYr" append-icon="mdi-magnify" @click:append="multiUwYrList = true"></v-text-field>
                        </v-flex>
                        <!-- Business Class -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field readonly v-model="reportForm.busCls" :label="labels.busCls" :error-messages="errors.collect('busCls')"
                          :data-vv-as="labels.busCls" data-vv-name="busCls" append-icon="mdi-magnify" @click:append="multiBusClsList = true"></v-text-field>
                        </v-flex>
                        <!-- Billing Account -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field readonly v-model="reportForm.inter" :label="labels.inter" :error-messages="errors.collect('inter')"
                          :data-vv-as="labels.inter" data-vv-name="inter" append-icon="mdi-magnify" @click:append="multiInterList = true"></v-text-field>
                        </v-flex>
                        <!-- Department -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field readonly v-model="reportForm.dept" :label="labels.dept" :error-messages="errors.collect('dept')"
                          :data-vv-as="labels.dept" data-vv-name="dept" append-icon="mdi-magnify" @click:append="multiDeptList = true"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-checkbox dense v-model="reportForm.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
        </v-flex>
        <v-flex xs12 sm6 md6 lg6>
          <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="reportForm.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Underwriting Year Helplist -->
    <v-dialog v-model="multiUwYrList" width="900px" persistent>
      <multi-uw-yr-help-list :uwYr="reportForm.uwYr" @close="multiUwYrList = false" @doAssign="doAssign('uwYr', $event)"></multi-uw-yr-help-list>
    </v-dialog>
    <!-- Business Class Helplist -->
    <v-dialog v-model="multiBusClsList" width="900px" persistent>
      <multi-bus-cls-help-list :busCls="reportForm.busCls" @close="multiBusClsList = false" @doAssign="doAssign('busCls', $event)"></multi-bus-cls-help-list>
    </v-dialog>
    <!-- Billing Account Helplist -->
    <v-dialog v-model="multiInterList" width="900px" persistent>
      <multi-intermediary-help-list
        :intr="reportForm.inter"
        :intrGrp="intrGrp"
        :listName="'billAcctNoList'"
        helpListTitle="Billing Account Helplist"
        @close="multiInterList = false" @doAssign="doAssign('inter', $event)"></multi-intermediary-help-list>
    </v-dialog>
    <!-- Department Helplist -->
    <v-dialog v-model="multiDeptList" width="900px" persistent>
      <multi-dept-help-list :dept="reportForm.dept" @close="multiDeptList = false" @doAssign="doAssign('dept', $event)"></multi-dept-help-list>
    </v-dialog>

  </div>
  <!-- </page> -->
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import { driList } from './index'
import MultiUwYrHelpList from '@/components/core/common/dialog/MultiUwYrHelpList'
import MultiBusClsHelpList from '@/components/core/common/dialog/MultiBusClsHelpList.vue'
import MultiIntermediaryHelpList from '@/components/core/common/dialog/MultiIntermediaryHelpList.vue'
import MultiDeptHelpList from '@/components/core/common/dialog/MultiDeptHelpList.vue'

export default {
  data() {
    return {
      labels: {
        dateRange: 'Date Range',
        filters: 'Selection Criteria',
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        dri: 'Direct/RI',
        uwYr: 'Underwriting Year(s)',
        busCls: 'Business Class(es)',
        inter: 'Billing Account(s)',
        dept: 'Department(s)',
        export: 'Export To',
        format: 'ASCII TEXT',
        printRptRunTime: 'Print Runtime Parameters'
      },
      reportForm: {
        tranDateFrom: null,
        tranDateTo: null,
        dri: 'B',
        uwYr: 'All',
        busCls: 'All',
        inter: 'All',
        dept: 'All',
        format: undefined,
        printRptRunTime: true
      },
      loading: false,
      menu: {},
      supportedFormat: [],
      driList: [],
      intrGrp: '10,11,12,13,20',
      // helplist
      multiUwYrList: false,
      multiBusClsList: false,
      multiInterList: false,
      multiDeptList: false,
      panel1: [0],
      panel2: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    tranDateFromValidation() {
      if (this.reportForm.tranDateFrom !== '' && this.reportForm.tranDateFrom !== null && this.reportForm.tranDateFrom !== undefined) {
        return 'entry|valTranDateFrom:' + this.reportForm.tranDateTo
      } else {
        return 'required'
      }
    },
    tranDateToValidation() {
      if (this.reportForm.tranDateTo !== '' && this.reportForm.tranDateTo !== null && this.reportForm.tranDateTo !== undefined) {
        return 'entry|valTranDateTo:' + this.reportForm.tranDateFrom
      } else {
        return 'required'
      }
    }
  },
  watch: {
  },
  methods: {
    async doInit() {
      this.reportForm.tranDateTo = new Date()
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await Promise.all([this.$store.dispatch('uwReportsInit')])
        }
        const apiURI = this.rptMenu.initPremAnalysis1
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doAssign(field, Obj) {
      switch (field) {
        case 'uwYr':
          this.reportForm.uwYr = Obj.finalSelectedItems.toString()
          break
        case 'busCls':
          this.reportForm.busCls = Obj.finalSelectedItems.toString()
          break
        case 'inter':
          this.reportForm.inter = Obj.finalSelectedItems.toString()
          break
        case 'dept':
          this.reportForm.dept = Obj.finalSelectedItems.toString()
          break
      }
    },
    doClose() {
      this.field = null
      this.polTypeHelpList = false
    },
    async processExport() {
      const apiURI = this.menu.exportPremAnalysis1BusCls
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.reportForm)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.driList = driList

    this.$validator.extend('valTranDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranFromDate = args[0]
        if (tranFromDate) {
          return !(isAfter(removeTime(value), removeTime(tranFromDate)))
        }
      }
    })

    this.$validator.extend('valTranDateTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranToDate = args[0]
        if (tranToDate) {
          return !(isAfter(removeTime(tranToDate), removeTime(value)))
        }
      }
    })
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    MultiUwYrHelpList,
    MultiBusClsHelpList,
    MultiIntermediaryHelpList,
    MultiDeptHelpList
  }
}
</script>

<style>

</style>
